import axios from 'axios'
import * as types from '../mutation-types'

// state
export const state = {
  loading: true,
  diaries: [],
  error: null,
}

const doToArrayObject = (data) => {
  const array = []
  let i = 0
  for (i in data) {
    if (data.hasOwnProperty(i)) {
      const contract = data[i].contrato || null
      array.push({
        value: data[i].id,
        createdAt: data[i].created_at,
        projectId: data[i].proyecto_id,
        text: contract ? contract.nombre : '',
        contractId: contract ? contract.id : '',
        typeContractId: data[i].tipo_contrato_id,
      })
    }
  }

  return array
}

// mutations
export const mutations = {
  [types.GET_HOUSE_DIARIES_START] (state) {
    state.loading = true
    state.diaries = []
    state.error = null
  },

  [types.GET_HOUSE_DIARIES_SUCCESS] (state, { data }) {
    state.loading = false
    state.diaries = doToArrayObject(data)
    state.error = null
  },

  [types.GET_HOUSE_DIARIES_ERROR] (state, { error }) {
    state.loading = false
    state.diaries = []
    state.error = error
  },
}

export const actions = {
  async getHouseDiaries ({ commit }, { projectId, createdAt }) {
    try {
      commit(types.GET_HOUSE_DIARIES_START)

      const { data } = await axios.get(`/api/diarios/find/contracts/${projectId}/${createdAt}`)

      commit(types.GET_HOUSE_DIARIES_SUCCESS, { data: data })
    } catch (e) {
      commit(types.GET_HOUSE_DIARIES_ERROR, { error: null })
    }
  },
}

// getters
export const getters = {
  loadingDiaries: state => state.loading,
  diaries: state => state.diaries,
  errorDiaries: state => state.error,
}
